import "./styles.scss";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { Button, Form, Input, message } from "antd";
import { login } from "../../redux/slices/userSlice";
import Header from "../../components/header";
import { POST } from "../../utils/apiCalls";
import API from "../../config/api";

function LoginScreen() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    try {
      setIsLoading(true);

      if (isForgotPassword) {
        const response: any = await POST(API.ADMIN_FORGOT_PASSWORD, {
          email: values?.email,
        });

        if (response?.status) {
          message.success(
            response.message ||
              "Password reset link has been sent to your email"
          );
          setIsForgotPassword(false);
          form.resetFields();
        } else {
          message.error(
            response?.message || "Failed to send reset link. Please try again."
          );
        }
      } else {
        const response: any = await POST(API.ADMIN_LOGIN, {
          email: values?.username,
          password: values?.password,
        });

        if (response?.status) {
          const userData = response.data;
          dispatch(login(userData));
          message.success(response.message || "Login successful");
          navigate("/admin/home");
        } else {
          message.error(response?.message || "Login failed. Please try again.");
        }
      }
    } catch (err: any) {
      console.error("Error:", err);
      message.error(
        isForgotPassword
          ? "Failed to send reset link. Please try again."
          : "Login failed. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="LoginScreen">
      <Header />
      <Container>
        <Row>
          <Col sm={4} xs={12}></Col>
          <Col sm={4} xs={12}>
            <div
              className="LoginScreen-Box"
              style={{
                padding: "40px",
                background: "#fff",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <div
                className="LoginScreen-txt1"
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  textAlign: "center",
                  marginBottom: "24px",
                }}
              >
                {isForgotPassword ? "Reset Password" : "Login Now"}
              </div>
              <Form form={form} onFinish={onFinish} layout="vertical">
                {isForgotPassword ? (
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "Please enter your email" },
                      { type: "email", message: "Please enter a valid email" },
                    ]}
                    initialValue={"xentrybook@gmail.com"}
                  >
                    <Input
                      defaultValue={"xentrybook@gmail.com"}
                      placeholder="Enter your email"
                      size="large"
                      type="email"
                    />
                  </Form.Item>
                ) : (
                  <>
                    <Form.Item
                      name="username"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your username or email",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter username or email"
                        size="large"
                      />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your password",
                        },
                      ]}
                    >
                      <Input.Password
                        placeholder="Enter password"
                        size="large"
                      />
                    </Form.Item>
                  </>
                )}
                <Form.Item>
                  <Button
                    block
                    type="primary"
                    htmlType="submit"
                    size="large"
                    loading={isLoading}
                  >
                    {isForgotPassword ? "Submit" : "Login"}
                  </Button>
                </Form.Item>
                <div
                  className="forgot-password-link"
                  onClick={() => {
                    setIsForgotPassword(!isForgotPassword);
                    form.resetFields();
                  }}
                  style={{
                    textAlign: "center",
                    color: "#3b82f6",
                    cursor: "pointer",
                    marginTop: "16px",
                  }}
                >
                  {isForgotPassword ? "Back to Login" : "Forgot Password?"}
                </div>
              </Form>
            </div>
          </Col>
          <Col sm={4} xs={12}></Col>
        </Row>
      </Container>
    </div>
  );
}

export default LoginScreen;
